var CutoutsWindow = {
  component: function() {
    return RshopApp.$children.find(function(component) {
      return component.$vnode.componentOptions.tag == "cutouts-window";
    });
  }
};

$(document).on("click", ".js-cutouts-trigger", function() {
  var cartId = $(this).attr('data-cart-id') ? $(this).attr('data-cart-id') : $(this).parents(".js-shopping-product").data("cart-id");
  var $productRowEl = $(this).closest('.js-shopping-products-row');
  var $cutoutsEl = $productRowEl.find('.js-cutouts-el');
  var component = CutoutsWindow.component();

  if (!component.loading) {
    $(".js-cutouts-modal").modal("show");

    $.get(
      "/priprava-otvorov/" + cartId,
      {},
      function(response) {
        if (!response.status) {
          return;
        }

        component.product = response.product;
        component.isRotated = response.is_rotated;
        component.checked = response.checked;
        component.cutoutsEl = $cutoutsEl;
        component.productRowEl = $productRowEl;
        component.image = response.image;
        component.positions = response.positions;
        component.cartId = cartId;
        component.cutoutsSizes = [];
        component.calculateSizes();

        $(window).off('resize', component.calculateSizes);
        $(window).on('resize', component.calculateSizes);
      },
      "json"
    );
  }
});

$(document).on("hidden.bs.modal", ".js-cutouts-modal", function() {
  var component = CutoutsWindow.component();

  if (!component.loading) {
    component.product = null;
    component.isRotated = false;
    component.checked = [];
    component.cutoutsEl = null;
    component.productRowEl = null;
    component.cartId = null;
    component.cutoutsSizes = [];
  }
});

var UpsellWindowComponent = Vue.component("cutouts-window", {
  template: "#cutoutsWindowTemplate",
  name: "cutouts-window",
  data: function() {
    return {
      product: null,
      checked: [],
      cutoutsEl: null,
      productRowEl: null,
      image: null,
      positions: [],
      loading: false,
      cartId: null,
      cutoutsSizes: [],
      isRotated: false
    };
  },
  methods: {
    hide: function() {
      $(".js-cutouts-modal").modal("hide");

      this.product = null;
      this.checked = [];
      this.cutoutsEl = null;
      this.productRowEl = null;
      this.cartId = null;
      this.cutoutsSizes = [];
      this.isRotated = false;
    },
    selectedIndex: function(id) {
      return this.checked.indexOf(id.toString());
    },
    hasOffCenter: function(position) {
      return position.offCenterX && position.offCenterY;
    },
    calculateSizes: function() {
      if (typeof this.$refs.cutoutImage !== 'undefined') {
        var image = this.$refs.cutoutImage,
          width = image.width,
          height = image.height,
          naturalWidth = image.naturalWidth,
          naturalHeight = image.naturalHeight;

        if (naturalWidth === 0 && naturalHeight === 0) {
          $(image).one('load', this.calculateSizes);
        }
        else {
          for (var i in this.positions) {
              Vue.set(this.cutoutsSizes, this.positions[i].key, {
                width: this.positions[i].realHeight ? 2 * Math.round(width / naturalWidth * this.positions[i].realHeight / 2) : 30,
                height: this.positions[i].realWidth ? 2 * Math.round(height / naturalHeight * this.positions[i].realWidth / 2) : 30
              });
          }
        }
      }
    },
    getSize: function(position) {
      var width = position.realWidth || 30,
        height = position.realHeight || 30;

      if (this.cutoutsSizes.length) {
        width = this.cutoutsSizes[position.key].width;
        height = this.cutoutsSizes[position.key].height;
      }

      return {
        width: width + 'px',
        height: height + 'px'
      };
    },
    getOffset: function(position) {
      var top = parseFloat(position.offsetY),
        left = parseFloat(position.offsetX);

      if (this.hasOffCenter(position)) {
        top += parseFloat(position.offCenterY);
        left += parseFloat(position.offCenterX);
      }

      return {
        top: top + "%",
        left: left + "%"
      };
    },
    addCutout: function(id) {
      if (!this.product) {
        return;
      }

      this.checked.push(id.toString());
    },
    removeCutout: function(index) {
      if (!this.product) {
        return;
      }

      this.checked.splice(index, 1);
    },
    removeCutoutsAndSave: function() {
      if (!this.product) {
        return;
      }

      this.checked = [];
      this.isRotated = false;
      this.save();
    },
    save: function() {
      var _self = this,
        cartId = _self.cartId,
        $productRow = _self.productRowEl,
        requestData = {
            cutouts: _self.checked
        };

      if (_self.isRotated) {
        requestData.is_rotated = true;
      }

      $productRow.addClass("is-loading");
      $(".js-cutouts-trigger").addClass("is-loading");

      _self.loading = true;

      _self.fetch(
        "post",
        "/priprava-otvorov/" + cartId,
        requestData,
        function(response) {
            var $cutoutsText = _self.cutoutsEl;
            var $imageEl = $cutoutsText.find(".js-image")
            var $countEl = $cutoutsText.find(".js-count")
            var $orientationEl = $cutoutsText.find(".js-orientation")

            const countPlural = $countEl.data('plural');
            $countEl.html(Format.plural(countPlural[0], countPlural[1], countPlural[2], _self.checked.length).replace(':count', _self.checked.length));
            $orientationEl.html($orientationEl.data(_self.isRotated ? 'rotated' : 'default-orientation'));

            $cutoutsText.toggleClass("has-cutouts", _self.checked.length > 0);
            $imageEl.toggleClass("is-rotated", _self.isRotated);

            $imageEl.attr("src", Eshop.image(_self.image, 'xs'));

            window.location.reload();
        },
        "json"
      );
    }
  },
  updated: function() {
    this.$nextTick(function() {
      tippy(".js-tippy-white", {
        arrow: true,
        theme: "white"
      });

      if (!this.cutoutsSizes.length) {
        this.calculateSizes();
      }
    });
  }
});
